import $ from "jquery";
import product from "../data/product";
import Constants from "../business/Constants";
import GigyaManager from "./GigyaManager";
import CollectionPromoApi from "mbpromo/src/collection-api/CollectionPromoApi";
import DeviceDetector from "device-detector-js";
import moment from "moment";

var Utility = {
	prepareProducts(UID) {
		$('.show-products').on('click', function() {
			$('.products-wrapper').scrollTop(0);
			$('.products-wrapper').fadeIn();
			$('body').addClass('noScroll');
			Utility.trackEvent(UID,"OPENPRODUCT_MODAL");
		});

		$('.products-close').on('click', function() {
			$('.products-wrapper').fadeOut();
			$('body').removeClass('noScroll');
		})
	},

	buildProductsList() {
		let productsListStructure = `
		<div class="products-wrapper" style="display: none;">
			<div class="product-close-wrapper content-wrapper-cnt">
				<div class="products-close">
					<svg>
						<use xlink:href="#svg_circle_close"></use>
					</svg>
				</div>
			</div>
			<div class="products-title">Trovi 1 punto colazione nei seguenti prodotti</div>
			<div class="products-list content-wrapper-cnt">
			</div>
		</div>`;
		$('.mb-promo').append(productsListStructure);
	},

	getDeviceInfo() {
		let deviceDetector = new DeviceDetector();
		let userAgent = navigator.userAgent;
		let device = deviceDetector.parse(userAgent);

		return device = {
			browserName: device.client.name,
			browserVersion: device.client.version,
			osVersion: device.os.version,
			osName: device.os.name,
			device: device.device.type
		}
	},

	printUserPreFooter() {
		let userPreFooterHtml = `
			<div class="prefooter-cnt">
				<h2 class="prefooter-title">Scopri dove trovare i prodotti che <br>partecipano alla Raccolta Punti <br>Colazione Mulino Bianco 2022.</h2>
				<p class="prefooter-claim">Clicca qui per vedere i punti vendita aderenti.</p>
				<a href="/trova-promozioni" class="button prefooter-btn">Trova l’evento più vicino a te</a>
			</div>
		`;
		$('.user-landing').after(userPreFooterHtml);
		this.initProducts(this.userID);
	},

	preCompileForm(data) {
		if (data.nome) {
			$("[name='firstName']").val(data.nome).attr('readonly','readonly');
		}
		if (data.cognome) {
			$("[name='lastName']").val(data.cognome).attr('readonly','readonly');
		}
		if(data.ind_toponimo) {
			$("[name='address']").val(data.ind_toponimo);
		}
		if (data.citofono) {
			$("[name='notes']").val(data.citofono);
		}
		if (data.ind_denurb) {
			$("[name='addressType']").val(data.ind_denurb.toUpperCase());
		}
		if (data.ind_civico) {
			$("[name='addressNum']").val(data.ind_civico);
		}
		if (data.cap) {
			$("[name='cap']").val(data.cap);
		}
		if (data.provincia) {
			$("[name='prov']").val(data.provincia);
		}
		if (data.citta) {
			$("[name='city']").html('').append(`<option value="${data.citta}" selected>${data.citta}</option>`);
		}
		if (data.telefono) {
			$("[name='tel']").val(data.telefono != null ? data.telefono : (data.cellulare != null ? data.cellulare : ''));
		}
	},

	fillCapProvCityForm(cap) {
		this.collectionPromoApi = new CollectionPromoApi({promoCode: Constants.API_PROMOCODE});
		if (cap && cap.length == 5) {
			this.collectionPromoApi.capUtil(3, {"cap": cap}).then((resp) => {
				if (resp.body.localita[0]) {
					let checkSelected = resp.body.localita.length == 1 ? 'selected' : '';
					Utility.startLoader();
					let body = resp.body.localita[0];

					$('[name="cap"]').val(cap);
					$('[name="city"]').html('');
					if (resp.body.localita.length > 1) {
						$('[name="city"]').append(`<option selected disabled value="">Seleziona...</option>`);
					}

					$.each(resp.body.localita, function() {
						$('[name="city"]').append(`<option value="${this.nome}" ${checkSelected}>${this.nome}</option>`);
					})

					$('[name="prov"]').val(body.provincia);
					$('.location-cnt .pristine-error').html('').hide();
					Utility.removeLoader();
				} else {
					$('[name="city"]').html('');
					$('[name="city"]').val('')
					$('[name="prov"]').val('');
				}
			}, (resp) => {
				console.log(resp.message)
			})
		}
	},

	getUrlParameter(sParam) {
		let sPageURL = decodeURIComponent(window.location.search.substring(1)),
			sURLVariables = sPageURL.split('&'),
			sParameterName,
			sParameterValue,
			index,
			i;

		for (i = 0; i < sURLVariables.length; i++) {
			index = sURLVariables[i].indexOf('=');
			sParameterName = sURLVariables[i].slice(0, index);
			sParameterValue = sURLVariables[i].slice(index + 1);

			if (sParameterName === sParam) {
				return sParameterValue === undefined ? true : sParameterValue;
			}
		}
	},

	trackDownloadBadge() {
		let userID = "";
		GigyaManager.getLoggedUserCached().then((u) => {
			userID = u.UID;
		});
	},

	retrieveProducts() {
		$.each(product.response.data, function() {
			let productCard = `
				<a class="product-item" href="https://mulinobianco.it/${this.link}?yxp-from-promo=${Constants.PROMO_CODE}" target="_blank">
					<img class="product-img" src="${this.image}"></img>
					<div class="product-title">${this.title}</div>
				</a> 
			`;
			$('.products-list').append(productCard);
		})
	},

	buildForm(isEdit, email) {
		let backToLink = isEdit ? `<a href="/promozioni/raccolta-punti-colazione/area-personale" class="editForm_backTo">torna alla tua pagina Personale</a>` : '';
		let ctaCnt = isEdit
			? `<div class="cta-cnt">
							<a class="button button--gold" href="/promozioni/raccolta-punti-colazione/area-personale" target="_self">Annulla</a>
						<div class="button proceed">Salva</div>
					</div>`
			: `<div class="cta-cnt">
						<a class="button button--gold" href="/promozioni/raccolta-punti-colazione" target="_self">Torna alla raccolta</a>
						<div class="button proceed">Conferma ed entra</div>
					</div>`;
		let formClassName = isEdit ? 'user-edit-form' : 'user-register-form';
		let registeredUserFormHtml = `
			<div class="main-cta content-wrapper-cnt ${formClassName}">
				${backToLink}
				<h2>I tuoi dati personali</h2>
				<p>Questa pagina è dedicata ai tuoi dati personali.<br/>Da ora puoi modificarli o aggiornarli in ogni momento e in totale autonomia.</p>
				<div class="recap-registered-user">
					<span class="recap-title"><b>Riepilogo dei tuoi dati:</b></span>
					<span class="recap-value">Email: <span class="input-like">${email}</span>
				</div>
				<span class="required-warning">I dati contrassegnati da asterisco (*) sono obbligatori.</span>
				<form class="registered-user" name="registeredUser" id="registered-user-form">
					<div class="user-cnt">
						<div class="name-field field-cnt form-group">
							<label>Nome*</label>
							<input 
								type="text" 
								name="firstName" 
								class="gigya-autocomplete-firstName" 
								minlength="2"
                           		maxlength="60"
                           		data-pristine-minlength-message="Il campo deve essere superiore a 2"
								placeholder="Mario" 
								required
								data-pristine-pattern= "/^[a-zA-ZàáâäãåèéêëìíîïòóôöõøùúûüÿýñçčšžÀÁÂÄÃÅÈÉÊËÌÍÎÏÒÓÔÖÕØÙÚÛÜŸÝÑßÇŒÆČŠŽ∂ð .'-]+$/i"
                           		data-pristine-pattern-message="Il campo contiene caratteri non consentiti"
								data-pristine-required-message="campo obbligatorio">
						</div>
						<div class="surname-field field-cnt form-group">
							<label>Cognome*</label>
							<input 
								type="text" 
								name="lastName" 
								class="gigya-autocomplete-lastName" 
								minlength="2"
                           		maxlength="60"
                           		data-pristine-minlength-message="Il campo deve essere superiore a 2"
								placeholder="Rossi" 
								required 
								data-pristine-pattern= "/^[a-zA-ZàáâäãåèéêëìíîïòóôöõøùúûüÿýñçčšžÀÁÂÄÃÅÈÉÊËÌÍÎÏÒÓÔÖÕØÙÚÛÜŸÝÑßÇŒÆČŠŽ∂ð .'-]+$/i"
                           		data-pristine-pattern-message="Il campo contiene caratteri non consentiti"
								data-pristine-required-message="campo obbligatorio">
						</div>
					</div>
					<div class="notes-cnt field-cnt form-group">
						<label>Indicazione su campanello / citofono*</label>
						<input type="text" name="notes" placeholder="Mario" required data-pristine-required-message="campo obbligatorio">
					</div>
					<div class="address-cnt field-cnt form-group">
						<label>Indirizzo (Via e Numero civico)*</label>
						<div class="address-field">
							<div class="form-group address-type">
								<select name="addressType" class="address-select" required data-pristine-required-message="campo obbligatorio">
								<option value="">Seleziona...</option>
								<option value="VIA">Via</option>
								<option value="VIALE">Viale</option>
								<option value="PIAZZA">Piazza</option>
								<option value="CORSO">Corso</option>
								<option value="STRADA">Strada</option>
								<option value="BORGATA">Borgata</option>
								<option value="BORGO">Borgo</option>
								<option value="CALATA">Calata</option>
								<option value="CALLE">Calle</option>
								<option value="CIRCONVALLAZIONE">Circonvallazione</option>
								<option value="CONTRADA">Contrada</option>
								<option value="FRAZIONE">Frazione</option>
								<option value="GALLERIA">Galleria</option>
								<option value="LARGO">Largo</option>
								<option value="LOCALITÀ">Località</option>
								<option value="LUNGOMARE">Lungomare</option>
								<option value="PARCO">Parco</option>
								<option value="PIAZZALE">Piazzale</option>
								<option value="PIAZZETTA">Piazzetta</option>
								<option value="SALITA">Salita</option>
								<option value="STRADA STAT.">Strada Stat.</option>
								<option value="STRADONE">Stradone</option>
								<option value="TRAVERSA">Traversa</option>
								<option value="VICO">Vico</option>
								<option value="VICOLO">Vicolo</option>
								<option value="VILLAGGIO">Villaggio</option> 
							</select>
							</div>
							<div class="form-group address-text">
								<input name="address" type="text" class="gigya-autocomplete-address" placeholder="della Costituzione" required data-pristine-required-message="campo obbligatorio">
							</div>
							<div class="form-group address-num">
								<input name="addressNum" type="text"  placeholder="1" required data-pristine-required-message="campo obbligatorio">
							</div>
						</div>
					</div>
					<div class="location-cnt">
						<div class="cap-field field-cnt form-group">
							<label>CAP*</label>
							<input 
							type="text" 
							class="gigya-autocomplete-zip" 
							name="cap" 
							maxlength="5"
							placeholder="00000" 
							data-pristine-pattern="/^\\d{5}(?:[-\\s]\\d{4})?$/"
							data-pristine-minlength-message="Il campo deve essere composto da 5 caratteri numerici"
                           	data-pristine-maxlength-message="Il campo deve essere composto da 5 caratteri numerici"
                           	data-pristine-pattern-message="Il campo deve essere composto da 5 caratteri numerici"
							required 
							data-pristine-required-message="campo obbligatorio">
						</div>
						<div class="city-field field-cnt form-group">
							<label>Località*</label>
							<select type="text" class="gigya-autocomplete-city city-select" name="city" placeholder="Roma" required data-pristine-required-message="campo obbligatorio">
								<option value="TEST" selected>TEST</option>
							</select>
						</div>
						<div class="prov-field field-cnt form-group">
							<label>Provincia*</label>
							<input type="text" placeholder="RM" class="prov gigya-autocomplete-codProvince" name="prov" maxlength="2" value="RM" required readonly data-pristine-required-message="campo obbligatorio">
						</div>
					</div>
					<div class="tel-cnt field-cnt form-group">
						<label>Telefono* (fisso o cellulare)</label>
						<input 
							type="tel" 
							placeholder="3333333333" 
							class="tel gigya-autocomplete-mobilePhone" 
							name="tel"
							minlength="8"
                           	maxlength="18"
                           	data-pristine-minlength-message="Il campo deve essere superiore a 8"
                           	data-pristine-pattern= "/^[+0-9 ]+$/"
                           	data-pristine-pattern-message="Il campo contiene caratteri non consentiti"
							required 
							data-pristine-required-message="campo obbligatorio">
					</div>
					<div class="privacy-cnt form-group">
						<input type="checkbox" name="acceptance" class="acceptance-checkbox" value="accetto" required data-pristine-required-message="campo obbligatorio">
						<label for="acceptance" class="acceptance-label">*Letta l’informativa dichiaro di essere maggiorenne, accetto il regolamento della “Nuova Raccolta Punti Colazione Mulino Bianco 2022” e presto il consenso al trattamento dei miei dati personali per l’invio di comunicazioni transazionali relative a questa Raccolta Punti, nonché per accedere ai servizi offerti, controllare lo stato di ogni mia richiesta premio e stampare le tessere personalizzate con i dati da me forniti in fase di registrazione a uno dei siti di Titolarità di Barilla.<br>Puoi consultare il regolamento integrale cliccando <a href='/promozioni/raccolta-punti-colazione/regolamento' target='_blank'>qui</a></label>
					</div>
					${ctaCnt}
				</form>
			</div>
		`;

		return registeredUserFormHtml;
	},

	trackEvent(userId,type) {
		try {
			// eslint-disable-next-line no-undef
			YXP_MB_TRACKER.send('EVENT',{payload:{
				contactId: userId,
				sourceUrl: window.location.href,
				promoCode: Constants.API_PROMOCODE,
				interactionType: type
			}});
		} catch (error) {
			console.log(error)
		}
	},

	removeLoader(){
		$('.tool_loader').fadeOut(500).remove();
		$('body').removeClass('noScroll');
	},

	startLoader(){
		$('.mb-promo').append('<div data-tool-loader="" class="tool_loader"><svg><use xlink:href="#svg_loader"></use></svg></div>');
		$('body').addClass('noScroll');
	},

	initProducts(UID) {
		this.buildProductsList();
		this.retrieveProducts();
		this.prepareProducts(UID);
		this.trackDownloadBadge();
	},

	getSurveyValidation() {
		return {
			'step1': {type: 'radio'},
			'step2a': {type: 'checkbox', minLength: 1},
			'step2b': {type: 'checkbox', minLength: 1, maxLength: 2},
			'step3': {type: 'radio', names: ['step3coccio', 'step3biscotazza', 'step3mattutina']},
			'step4': {type: 'radio', names: ['step4coccio', 'step4biscotazza', 'step4mattutina']},
			'step5': {type: 'radio'},
			'step6': {type: 'checkbox', minLength: 2, maxLength: 2},
		};
	},

	enableHolidaysMessage(){
		if(moment(Constants.HOLIDAYS_DATE, 'DD/MM/YYYY HH:mm').diff(moment()) < 0){
			$('#message-holidays').hide();
		}
	}
}

export default Utility;